import { useContext, useState } from "react";
import * as Scrivito from "scrivito";
import CookiesDeclinedBanner from "^/Components/PlaceholderWithCookieConsent";
import { CookieConsentContext } from "^/Components/CookieConsentContext";
import { isBrowser } from "^/utils/isBrowser";

const PlaceholderOrOpenStreetMapComponent = Scrivito.connect(
  ({ _widget, children }) => {
    const { optionAllowed, setOptions } = useContext(CookieConsentContext);
    const [updated, setUpdated] = useState(0);

    if (!optionAllowed("openstreetmap")) {
      const currPage = Scrivito.currentPage();
      const lang = currPage.language();

      return (
        <CookiesDeclinedBanner
          icon="las la-map-marked-alt"
          onAccept={() => {
            setOptions("openstreetmap", true);
            setUpdated(updated + 1);
          }}
          lang={lang}
          serviceType="map"
        />
      );
    }

    // leaflet is not SSR-compatible, so we have to require it dynamically
    if (!isBrowser) return null;

    return children;
  }
);

export default PlaceholderOrOpenStreetMapComponent;
